export default __webpack_public_path__ + "static/media/streamLinedInventory.281d158a.jpg";